module.exports = __webpack_public_path__ + "images/emoji/passport_control.861539459392ee5857dc.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/passport_control.png
// module id = fuuJ
// module chunks = 2